import { render, staticRenderFns } from "./quality-control.vue?vue&type=template&id=6d8169eb&"
import script from "./quality-control.vue?vue&type=script&lang=js&"
export * from "./quality-control.vue?vue&type=script&lang=js&"
import style0 from "./quality-control.vue?vue&type=style&index=0&id=6d8169eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports